import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import MissionVision from "@/components/MissionVision";
import Services from "@/components/Services";
import Distintivos from "@/components/Distintivos";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <About />
        <MissionVision />
        <Services />
        <Distintivos />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
